import React, { useState } from 'react'
import { useTheme } from '@mui/material'
import { IconButton } from '@center/ui-kit'
import { MapTypeContainer } from './MapTypeStyles'
import { useTranslation } from 'react-i18next'
import ControlsTooltipWrapper from '../ControlsTooltipWrapper'


enum MAP_TYPES {
  'SATELLITE' = 'SATELLITE',
  'MAP' = 'MAP',
}

interface MapTypeProps {
  mapsView?: string;
  handleRoadmapClick?: () => void;
  handleSatelliteClick?: () => void;
  isProjectHomeView?: boolean;
  [key: string]: any;
}

const MapType: React.FC<MapTypeProps> = ({
  mapsView,
  handleRoadmapClick = () => {},
  handleSatelliteClick = () => {},
  isProjectHomeView = false,
  ...props
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [mapType, setMapType] = useState<keyof typeof MAP_TYPES>(MAP_TYPES.MAP)

  const handleClick = () => {
    switch (mapType) {
      case MAP_TYPES.MAP:
        setMapType(MAP_TYPES.SATELLITE)
        handleSatelliteClick()
        break
      case MAP_TYPES.SATELLITE:
        setMapType(MAP_TYPES.MAP)
        handleRoadmapClick()
        break
      default:
        break
    }
  }

  const getIcon = () => {
    switch (mapType) {
      case MAP_TYPES.SATELLITE:
        return 'fa-map'
      case MAP_TYPES.MAP:
      default:
        return 'fa-satellite'
    }
  }

  const getTranslation = () => {
    switch (mapType) {
      case MAP_TYPES.SATELLITE:
        return 'cartography.maps.controls.map_map'
      case MAP_TYPES.MAP:
      default:
        return 'cartography.maps.controls.map_satellite'
    }
  }

  return (
    <MapTypeContainer
      isProjectHomeView={isProjectHomeView}
      className={mapsView !== 'building' ? 'globalsite' : ''}
    >
      <ControlsTooltipWrapper title={t(getTranslation())} arrow placement='left'>
        <IconButton
          color={isProjectHomeView ? 'white' : "grey"}
          variant="text"
          sx={{
            width: 40,
            height: 40,
            '&:hover': {
              backgroundColor: 'transparent',
            },
            fontSize: '16px',
          }}
          onClick={handleClick}
        >
          <i className={`fa-regular ${getIcon()}`} />
        </IconButton>
      </ControlsTooltipWrapper>
    </MapTypeContainer>
  )
}

export default MapType
